import XesAxios from './XesAxios'
import homeApi from './home'
import otherApi from './other'
import uploadApi from './upload'
import commonApi from './common'
export default {
  // 检测登录态 - 首页
  checkLogin() {
    return XesAxios.post('//booster.xueersi.com/teacher/checkUserLoginStatus')
  },
  ...homeApi,
  ...otherApi,
  ...uploadApi,
  ...commonApi,
}
